import { ChapterHeader, FadeUp } from "./Motion";

export default function About({ content }) {
    const paragraphs = (content.biography || "").split("\n\n");
    return (
        <section id="about" className="relative py-20 md:py-32 border-t border-white/10">
            <div className="absolute -left-40 top-1/2 w-[600px] h-[600px] radial-purple pointer-events-none" />
            <div className="max-w-[1600px] mx-auto px-5 md:px-10 relative z-10">
                <ChapterHeader num="05" kicker="Manifesto" title="About the Athlete" testId="chapter-about" />

                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <FadeUp>
                            <div className="relative aspect-[3/4] overflow-hidden border border-white/10">
                                <img
                                    src={content.portraits.contact}
                                    alt="Portrait"
                                    className="w-full h-full object-cover clip-diagonal"
                                    data-testid="about-portrait"
                                />
                            </div>
                            <div className="mt-4 font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 flex justify-between">
                                <span>Portrait / 03</span>
                                <span>Wendell NC</span>
                            </div>
                        </FadeUp>
                    </div>
                    <div className="md:col-span-7">
                        {paragraphs.map((p, i) => (
                            <FadeUp key={i} delay={i * 0.08}>
                                <div className="border-t border-white/10 pt-6 mt-6 first:mt-0 first:border-t-0 first:pt-0">
                                    <div className="chapter-num">§ {String(i + 1).padStart(2, "0")}</div>
                                    <p
                                        className={`mt-3 ${
                                            i === 0
                                                ? "editorial text-2xl md:text-3xl leading-snug text-white"
                                                : "text-white/80 text-base md:text-lg leading-relaxed"
                                        }`}
                                    >
                                        {i === 0 && <span className="text-brand-gold">— </span>}
                                        {p}
                                    </p>
                                </div>
                            </FadeUp>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
